"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetTradePwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var SetTradePwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SetTradePwd, _super);
    function SetTradePwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '客户设置交易密码';
        _this.code = '101018';
        _this.desc = '客户设置交易密码';
        _this.requestParams = new password_1.SetTradePwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SetTradePwd;
}(service_1.BaseService));
exports.SetTradePwd = SetTradePwd;
//# sourceMappingURL=setTradePwd.js.map